// extracted by mini-css-extract-plugin
export default {"search_pagination_control":"Pagination_search_pagination_control__uOAEu"};